module.exports = __webpack_public_path__ + "img/singapore-featured-image-600x395.7b59f40c.jpg";